const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极致轻量',
    description: '核心库压缩后仅 4.8KB，零依赖，加载速度极快，对页面性能几乎无影响。',
  },
  {
    icon: 'ri-layout-masonry-line',
    title: '灵活布局',
    description: '支持水平导航、侧边栏、大型菜单、移动端汉堡菜单等多种布局模式自由切换。',
  },
  {
    icon: 'ri-paint-brush-line',
    title: '深度定制',
    description: '完善的 CSS 变量系统与 JavaScript API，轻松自定义颜色、间距、动画等所有细节。',
  },
  {
    icon: 'ri-device-line',
    title: '全端适配',
    description: '自带响应式断点策略，桌面、平板、手机三端完美呈现，触摸交互优化到位。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '无障碍支持',
    description: '严格遵循 WCAG 2.1 AA 标准，键盘导航、屏幕阅读器、色彩对比度全面达标。',
  },
  {
    icon: 'ri-code-box-line',
    title: '框架无关',
    description: '纯原生实现，可与 React、Vue、Angular 等任意前端框架或纯 HTML 项目无缝集成。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            为什么选择 <span className="text-primary-600">蓝色小导航</span>
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            精心打磨每一个细节，只为给开发者带来最好的导航组件体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature, i) => (
            <div
              key={i}
              className="group p-6 md:p-7 rounded-2xl bg-background-100/70 border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 hover:translate-y-[-4px]"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-600 mb-4 group-hover:bg-primary-100 transition-colors duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-950 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}